// extracted by mini-css-extract-plugin
export default {"button":"iWjCt9","back-arrow-icon":"vEB7bA","backArrowIcon":"vEB7bA"};